import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';

@Injectable()
export class AuthGuard  {

  constructor(private router: Router,
              private oauthService: OAuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasValidToken = this.oauthService.hasValidAccessToken();
    if (!hasValidToken) {
      localStorage.setItem('redirectTo', state.url);
      if (route.queryParams.auth) {
        this.router.navigateByUrl(route.queryParams.auth);
      }
    }
    return hasValidToken;
  }
}
